import {
    FETCH_FORMULABUILDERS_FAILURE,
    FETCH_FORMULABUILDERS_REQUEST,
    FETCH_FORMULABUILDERS_SUCCESS
} from "./formulaBuilderTypes"

const initialState = {
    loading: false,
    formulaBuilders: [],
    error: ''
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FORMULABUILDERS_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case FETCH_FORMULABUILDERS_SUCCESS:
            return {
                loading: false,
                formulaBuilders: action.payload,
                error: '',
            }
        case FETCH_FORMULABUILDERS_FAILURE:
            return {
                loading: false,
                formulaBuilders: [],
                error: action.payload
            }
        default: return state;
    }
}
export default reducer;